module.exports = "/_next/static/images/ashley-willis-48b81c9b3e50bc479f2db7858d762ad1.jpg";